<template>
  <v-app-bar color="primary" dark app height="64px"> <!--  clipped-left fixed  -->
    <div class="d-flex align-center mr-6">
      <!-- <img height="45" src="../../assets/logo.svg" alt="Logo"> -->
    </div>

    <v-toolbar-title>{{this.$route.name}}</v-toolbar-title>

    <!-- Botones -->
    <v-spacer></v-spacer>
    <v-tooltip bottom v-for="item in headerButtons" :key="item.name">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" :to="item.path">
          <v-icon>{{item.icon}}</v-icon>
        </v-btn>
      </template>
      <span>{{item.name}}</span>
    </v-tooltip>

    <v-divider class="mx-3" vertical></v-divider>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" v-on:click="initLogout">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </template>
      <span>Logout</span>
    </v-tooltip>
  </v-app-bar>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data: () => ({
    headerButtons: [
      {
        path: '/',
        icon: 'mdi-home',
        name: 'Analysis'
      },
      {
        path: '/processList',
        icon: 'mdi-list-status',
        name: 'Process List'
      },
      {
        path: '/fileManager',
        icon: 'mdi-file-document',
        name: 'File Manager'
      },
      {
        path: '/regions',
        icon: 'mdi-earth',
        name: 'Regions'
      },
      {
        path: '/map',
        icon: 'mdi-map',
        name: 'Map'
      }
    ]
  }),
  methods: {
    ...mapActions('auth', [
      'logout'
    ]),

    initLogout () {
      var self = this

      this.$root.$confirmDialog.open('Logout', 'Are you sure you want to logout?').then(result => {
        if (result) {
          self.logout()
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
